import { Box, Modal, Slider, Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import AvatarEditor from "react-avatar-editor";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import FaceIcon from "@mui/icons-material/Face";
import DeleteIcon from "@mui/icons-material/Delete";
import { Tooltip } from "@mui/material";
import AvatarSelector from "./AvatarSelector";
import SaveIcon from "@mui/icons-material/Save";
import Avatar from "../../layout/popup/PopupInfoDiet/Avatar";
import axios from "axios";

const boxStyle = {
  width: "40rem",
  height: "40rem",
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 20,
};
const modalStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  mrginTop: "10rem",
  zIndex: 1002,
};

// Modal
const CropperModal = ({
  src,
  modalOpen,
  setModalOpen,
  setPreview,
  setChangePic,
  setBlob,
}) => {
  const [slideValue, setSlideValue] = useState(10);
  const cropRef = useRef(null);

  const handleSave = () => {
    try {
      if (cropRef && cropRef.current) {
        const canvas = cropRef.current.getImage();

        canvas.toBlob((blob) => {
          if (blob) {
            setPreview(URL.createObjectURL(blob));
            setChangePic(true);
            setBlob(blob);
            setModalOpen(false);
          } else {
            console.error("Failed to convert canvas to blob.");
          }
        }, "image/png");
      }
    } catch (e) {
      console.error("Error while saving cropped image:", e);
    }
  };

  return (
    <Modal sx={modalStyle} open={modalOpen}>
      <Box sx={boxStyle}>
        <AvatarEditor
          ref={cropRef}
          image={src}
          style={{ width: "100%", height: "100%" }}
          border={50}
          borderRadius={150}
          color={[0, 0, 0, 0.72]}
          scale={slideValue / 10}
          rotate={0}
        />

        {/* MUI Slider */}
        <Slider
          min={10}
          max={50}
          sx={{
            margin: "0 auto",
            width: "80%",
            color: "cyan",
          }}
          size="medium"
          defaultValue={slideValue}
          value={slideValue}
          onChange={(e) => setSlideValue(e.target.value)}
        />
        <Box
          sx={{
            display: "flex",
            padding: "10px",
            border: "3px solid white",
            background: "black",
          }}
        >
          <ButtonPrimary
            outline
            text="Cancel"
            className="mr-2"
            onClick={(e) => setModalOpen(false)}
          />
          <ButtonPrimary text="Save" onClick={handleSave} />
        </Box>
      </Box>
    </Modal>
  );
};

const Cropper = ({
  preview,
  setPreview,
  setChangePic,
  setBlob,
  setShowAvatarSelector,
  showAvatarSelector,
  avatars,
  handleAvatarSelect,
  updateProfilePic,
  username,
  deleteProfilePic,
  email,
}) => {
  const [src, setSrc] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const inputRef = useRef(null);
  const [profilePopup, setProfilePopup] = useState(false);
  const [blobURL, setBlobURL] = useState(null);
  const [deletePopup, setDeletePopup] = useState(false);

  const handleInputClick = (e) => {
    e.preventDefault();
    inputRef.current.click();
  };

  const handleImgChange = (e) => {
    setSrc(URL.createObjectURL(e.target.files[0]));
    setModalOpen(true);
  };

  useEffect(() => {
    async function fetchImage() {
      try {
        const response = await axios.get(preview, { responseType: "blob" });
        const blob = new Blob([response.data], { type: "image/png" });
        setBlobURL(URL.createObjectURL(blob));
      } catch (error) {
        console.error("Error fetching the image:", error);
      }
    }

    fetchImage();
  }, [preview]);

  useEffect(() => {
    async function fetchImage() {
      try {
        const response = await axios.get(src, { responseType: "blob" });
        const blob = new Blob([response.data], { type: "image/png" });
        setBlobURL(URL.createObjectURL(blob));
      } catch (error) {
        console.error("Error fetching the image:", error);
      }
    }

    if (src) {
      fetchImage();
    }
  }, [src]);

  return (
    <div className="cropper">
      <main className="container cropper">
        <div className="img-container">
          {preview ? (
            <img
              src={preview}
              alt=""
              className="cropper-img"
              onClick={() => setProfilePopup(true)}
            />
          ) : (
            <Avatar
              name={localStorage.getItem("email")}
              size="20rem"
              fontSize="10rem"
              profile={preview}
            />
          )}

          <div onClick={() => setProfilePopup(true)} className="">
            <EditIcon className="hover-icon" />
          </div>
        </div>
        <CropperModal
          modalOpen={modalOpen}
          src={blobURL}
          setPreview={setPreview}
          setModalOpen={setModalOpen}
          setChangePic={setChangePic}
          setBlob={setBlob}
        />
        <div className="cropper-header">
          <p className="title">{username}</p>
          <p className="title-email">{email}</p>
        </div>
        <input
          type="file"
          accept="image/*"
          ref={inputRef}
          onChange={handleImgChange}
        />
      </main>
      {profilePopup && (
        <div>
          <div className="bg-dark" />
          <div className="hover-overlay">
            <CloseIcon
              onClick={() => setProfilePopup(false)}
              className="close-icon"
            />
            <div className="profile-section">
              {preview ? (
                <img
                  src={preview}
                  alt="Profile Preview"
                  className="profile-preview"
                />
              ) : (
                <Avatar
                  name={localStorage.getItem("email")}
                  size="20rem"
                  fontSize="10rem"
                  profile={preview}
                />
              )}
            </div>
            <div className="options-section">
              <div className="options-left">
                {preview && (
                  <p
                    onClick={() => {
                      setSrc(preview);
                      setModalOpen(true);
                    }}
                    className="col"
                  >
                    <EditIcon className="icon" />
                    <span>Edit</span>
                  </p>
                )}
                <p onClick={handleInputClick} className="col">
                  <AddPhotoAlternateIcon className="icon" />
                  <span>Add Image</span>
                </p>
                <input
                  type="file"
                  accept="image/*"
                  ref={inputRef}
                  onChange={handleImgChange}
                />

                {/* <p onClick={() => setShowAvatarSelector(true)} className="col">
                  <FaceIcon className="icon" />
                  <span>Add Avatar</span>
                </p> */}
              </div>
              <div className="options-right">
                {preview && (
                  <p onClick={updateProfilePic} className="col">
                    <SaveIcon className="icon" />
                    <span>Save Image</span>
                  </p>
                )}
                {preview && (
                  <p
                    onClick={() => {
                      setDeletePopup(true);
                    }}
                    className="col delete"
                  >
                    <DeleteIcon className="icon" />
                    <span>Delete</span>
                  </p>
                )}
                {showAvatarSelector && (
                  <AvatarSelector
                    avatars={avatars}
                    onSelect={handleAvatarSelect}
                    setShowAvatarSelector={setShowAvatarSelector}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {deletePopup && (
        <div className="delete-image">
          <div className="bg-dark"></div>
          <div className="delete-popup">
            <CloseIcon
              className="cross"
              onClick={() => {
                setDeletePopup(false);
              }}
            />

            <p className="popup-title">
              Are you sure you want to delete this Profile Pic?
            </p>
            <div className="save-actions">
              <div />
              <div className="flex">
                <ButtonPrimary
                  text="Cancel"
                  onClick={() => {
                    setDeletePopup(false);
                  }}
                  className="mr-2 grey"
                  outline
                />
                <ButtonPrimary text="Confirm" onClick={deleteProfilePic} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cropper;
